const interview_video = () => {
  var video = document.getElementById('videoInterview');
  if(video != null) {
    video.onended = function() {
      video.style.opacity = '0';
      video.addEventListener('transitionend', function() {
        video.style.display = 'none';
      }, { once: true });
    };
  }
};
